"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * The list Item component is used for displaying items in a list
 */

var defaultProps = {
  theme: {},
  role: null
};
var ListItem = exports["default"] = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(ListItem, _Component);
  /* istanbul ignore next */
  function ListItem(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ListItem);
    _this = _callSuper(this, ListItem, [props]);
    /* state needed for swapping out icons on hover */
    _this.state = {
      icon: props.icon
    };
    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseEnter = props.hoverIcon ? _this.handleMouseEnter.bind((0, _assertThisInitialized2["default"])(_this)) : null;
    _this.handleMouseLeave = props.hoverIcon ? _this.handleMouseLeave.bind((0, _assertThisInitialized2["default"])(_this)) : null;
    return _this;
  }
  (0, _createClass2["default"])(ListItem, [{
    key: "handleMouseEnter",
    value: function handleMouseEnter() {
      this.setState({
        icon: this.props.hoverIcon
      });
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      this.setState({
        icon: this.props.icon
      });
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(e) {
      var _this$props = this.props,
        onClick = _this$props.onClick,
        href = _this$props.href;

      // Check if the left button was clicked
      if (!href && onClick && e.button === 0) {
        onClick(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        isActive = _this$props2.isActive,
        onClick = _this$props2.onClick,
        onKeyDown = _this$props2.onKeyDown,
        href = _this$props2.href,
        target = _this$props2.target,
        theme = _this$props2.theme,
        className = _this$props2.className,
        testId = _this$props2.testId,
        style = _this$props2.style,
        getRef = _this$props2.getRef,
        tabIndex = _this$props2.tabIndex,
        role = _this$props2.role;
      var icon = this.state.icon;
      var propBasedClasses = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, theme.isActive, isActive), theme.hasIcon, icon), theme.hasClickHandler, onClick);
      var classes = (0, _classnames["default"])(theme.listItem, /* localized styles */
      className, /* user specified classNames */
      propBasedClasses /* prop based classnames */);
      var setFullWidthClass = !icon ? theme.fullWidth : null;
      var listItemContents = /*#__PURE__*/_react["default"].createElement("span", {
        className: theme.inner,
        "data-test-id": testId && "".concat(testId, "-inner")
      }, icon, /*#__PURE__*/_react["default"].createElement("span", {
        className: setFullWidthClass,
        "data-test-id": testId && "".concat(testId, "-wrap")
      }, this.props.children));
      if (href) {
        listItemContents = /*#__PURE__*/_react["default"].createElement("a", {
          ref: getRef,
          href: href,
          onClick: onClick,
          className: theme.link,
          "data-test-id": testId && "".concat(testId, "-href"),
          target: target,
          rel: "noopener noreferrer"
        }, listItemContents);
      }

      /* eslint-disable jsx-a11y/no-static-element-interactions */
      return /*#__PURE__*/_react["default"].createElement("li", {
        role: role,
        ref: href ? null : getRef,
        onMouseDown: this.handleMouseDown,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        onKeyDown: onKeyDown,
        style: style,
        tabIndex: tabIndex,
        className: classes,
        "data-test-id": testId,
        "data-anypoint-component": ListItem.displayName
      }, listItemContents);
    }
  }]);
  return ListItem;
}(_react.Component);
(0, _defineProperty2["default"])(ListItem, "displayName", 'ListItem');
(0, _defineProperty2["default"])(ListItem, "defaultProps", defaultProps);
//# sourceMappingURL=ListItem.js.map